









import { computed, defineComponent, PropType } from "@vue/composition-api";
import { ActivityCreditTransactionDetails } from "@scrile/api-provider/dist/api/ActivityCreditsProvider";
import { Transaction, TransactionContentType } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionActivityCredit",
  components: { TransactionView },
  props: {
    transaction: { type: Object as PropType<Transaction<ActivityCreditTransactionDetails>>, required: true },
  },
  setup(props) {
    const isComment = computed(() => props.transaction.contentType === TransactionContentType.COMMENT_CREDIT);

    return { isComment };
  },
});
